<template>
  <div>
    <!-- filters -->
    <div class="mb-4">
      <Filters @applyFilter="filter = $event"></Filters>
    </div>
  </div>
</template>

<script>
import Filters from './Filters.vue'

export default {
  components: {
    Filters
  },
  data () {
    return {
      filter: ''
    }
  }
}
</script>
